<template>
  <div class="home-page">
    <!-- 轮播图 -->
    <div class="home-banner">
      <el-carousel class="carousel" trigger="click" height="150px" loop>
        <el-carousel-item :class=" item.url && item.url!=='/'?'activedItem':''" v-for="(item, index) in bannerLists" :key="item.id" >
          <h3 class="small">
            <img :src="'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                  item.backgroundImage" @click="clickBanner(index, item)" alt="" />
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="home-container">
      <!-- 最近观看 -->
      <div v-if="userId&&lastedWatched.length>0" class="last-watch">
        <div class="title">最近观看的视频</div>
        <div class="content">
          <div class="item" v-for="item in lastedWatched" :key="item.id">
            <div class="img-box">
              <img
                :src="
                  'http://histo-education.oss-cn-beijing.aliyuncs.com' +(item.columnName&&item.columnName.indexOf('疑难病例')>-1?'/pcweb/poster':'')+
                  item.coverURL
                "
                alt=""
              />
            </div>
            <div class="desc">
              <div class="desc-title">{{ item.name }}</div>
              <div class="author">
                <div  v-show="item.teacherName" class="author-title">讲师</div>
                <div class="author-name">{{ item.teacherName }}</div>
              </div>
              <div class="saw-time">观看至{{item.times}}</div>
            </div>
            <div class="continue-btn">
              <el-button type="primary" size="default" @click='toVideo(item.courseID)'>继续观看</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 病理诊断系统 -->
      <div  v-if="pathologyCourseList.courses" class="system-course course" :style="{marginTop: userId?'80px':'41px'}">
        <div class="title">
          <div class="title-name">病理诊断体系课程</div>
          <div
            v-if="moreSystem===true"
            class="more"
            @click="toMoreCourse"
          >
            更多课程
          </div>
          <div v-else-if="moreSystem===false" class="more" @click="toLessCourse">
            收起
          </div>
        </div>
        <div ref="moreContent" class="content"  style="height:355px;overflow:hidden">
          <div
            class="img-box"
            v-for="item in pathologyCourseList.courses"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <img
              :src="
                'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                item.pcPoster
              "
              alt=""
            />
            <div class="img-desc">
              <div class="desc-title">{{item.name}}</div>
              <div class="desc-author">
                <div class="author-title">讲师</div>
                <div class="author-name">
                  {{ item.lecturerIntroduction }}教授
                </div>
                <div class="author-status">已订阅 |</div>
                <div class="author-number">{{ item.subscriptionNum }}人</div>
              </div>
              <el-button v-if="userId&&item.subscribed" class="order-btn" type="primary" disabled>已订阅</el-button>
              <el-button v-else class="order-btn" type="primary" @click.stop="subscribeItem(item.id)">订阅课程</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 衡道讲堂 -->
      <div v-if="HFirst&&Hlasted.length>0" class="hengdao-course course">
        <div class="title">
          <div class="title-name">衡道讲堂</div>
          <div
            v-if="hengMoreShow===true"
            class="more"
            @click="HMoreCourse"
          >
            更多课程
          </div>
          <div v-else-if="hengMoreShow===false" class="more" @click="HLessCourse">
            收起
          </div>
        </div>
        <div v-loading="hengLoading1" v-if="hengMoreShow===true" ref="HMoreContent1" style="height:440px" class="content hot-content">
          <div class="hot-item img-box" style="cursor:pointer" @click="toVideo(HFirst.id)">
            <img :src="'http://histo-education.oss-cn-beijing.aliyuncs.com' + HFirst.pcVerticalThumbnail" alt="" />
          </div>
          <div class="general-content">
            <div
              class="img-box"
              v-for="(item, index) in Hlasted"
              :key="item.id"
              @click="toVideo(item.id)"
            >
              <div class="img" @mouseover="mouseoverimg(index)" @mouseout="mouseoutimg(index)">
                <div ref="playicon" class="imgmask">
                  <i class="play-icon"></i>
                </div>
                <img
                  :src="
                    'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                    item.pcPoster
                  "
                  alt=""
                />
              </div>
              <div class="img-desc">
                <div class="desc-title">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-loading="hengLoading" v-if="hengMoreShow===false" ref="HMoreContent2" style="height:660px; overflow:hidden" class="content">
          <div
            class="img-box"
            v-for="(item, index) in HCourseList.courses"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <div class="img" @mouseover="mouseoverimg(index)" @mouseout="mouseoutimg(index)">
              <div ref="playicon" class="imgmask">
                <i class="play-icon"></i>
              </div>
              <img
                :src="
                  'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                  item.pcPoster
                "
                alt=""
              />
            </div>
            <div class="img-desc">
              <div class="desc-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 疑难病例讨论 -->
      <div v-if="IMDTCourseList.courses" class="IMDT-course course">
        <div class="title">
          <div class="title-name">
            IMDT & 疑难病例讨论
          </div>
          <div
            v-if="IMDMore===true"
            class="more"
            @click="toMoreIMDCourse"
          >
            更多课程
          </div>
          <div v-else-if="IMDMore===false" class="more" @click="toLessIMDCourse">
            收起
          </div>
        </div>

        <div ref="moreIMDContent" class="content" style="height:195px; overflow:hidden">
          <div
            class="img-box"
            v-for="item in IMDTCourseList.courses"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <div class="img">
              <img
                :src="
                  'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                  item.poster
                "
                alt=""
              />
            </div>
            <div class="img-desc">
              <div class="desc-title">{{ item.name }}</div>
              <!-- <div class="desc-origin">瑞金医院</div> -->
              <div class="desc-date">{{ item.updateTime }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 病理大咖说 -->
      <div v-if="masterCourseList.length>0"  class="tec-course master-course course">
        <div class="title">病理大咖说</div>
        <div class="content">
          <div
            class="img-box"
            v-for="(item, index) in masterCourseList"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <div class="img" @mouseover="mouseoverimgmaster(index)" @mouseout="mouseoutimgmaster(index)">
              <div ref="playiconMaster" class="imgmask">
                <i class="play-icon"></i>
              </div>
              <img
                :src="
                  'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                  item.pcPoster
                "
                alt=""
              />
            </div>
            <div class="img-desc">
              <div class="desc-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 白求恩肿瘤病理学社 -->
      <div  v-if="BethuneList.courses" class="bethuneList-course course">
         <div class="title">
          <div class="title-name">
           肿瘤病理学社
          </div>
          <div
            v-if="BethMore===true"
            class="more"
            @click="toMoreBethCourse"
          >
            更多课程
          </div>
          <div v-else-if="BethMore===false" class="more" @click="toLessBethCourse">
            收起
          </div>
        </div>
        <div class="content" ref="moreBethContent" style="height:200px; overflow:hidden">
          <div
            class="img-box"
            v-for="item in BethuneList.courses"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <img
              :src="
                'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                item.pcPoster
              "
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 技术达人精品课 -->
      <div v-if="tecCourseList.courses" class="tec-course course">
        <div class="title">技术达人精品课</div>
        <div class="content">
          <div
            class="img-box"
            v-for="(item, index) in tecCourseList.courses"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <div class="img" @mouseover="mouseoverimgtec(index)" @mouseout="mouseoutimgtec(index)">
              <div ref="playiconTec" class="imgmask">
                <i class="play-icon"></i>
              </div>
              <img
                :src="
                  'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                  item.pcPoster
                "
                alt=""
              />
            </div>
            <div class="img-desc">
              <div class="desc-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 「肺」你莫属，乘风破Lung的RET -->
<!--      <div v-if="academicCourseList.courses" class="lung-course course">-->
      <div v-if="false" class="lung-course course">
        <div class="title">「肺」你莫属，乘风破Lung的RET</div>
        <div class="content">
          <div
            class="img-box"
            v-for="item in lungList.courses"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <img :src="
                'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                item.pcPoster
              " alt="" />
          </div>
        </div>
      </div>
      <!-- 学术会议 -->
      <div v-if="academicCourseList.courses" class="academic-course course">
        <div class="title">学术会议</div>
        <div class="content">
          <div
            class="img-box"
            v-for="item in academicCourseList.courses"
            :key="item.id"
            @click="toVideo(item.id)"
          >
            <img
              :src="
                'http://histo-education.oss-cn-beijing.aliyuncs.com' +
                item.pcPoster
              "
              alt=""
            />
            <div class="img-desc">
              <div class="desc-title">{{ item.name }}</div>
              <div class="desc-detail">
                <div class="detail-title">{{ item.lecturerIntroduction }}</div>
                <div class="status">已订阅 | {{ item.subscriptionNum }}人</div>
              </div>
              <el-button v-if="userId&&item.subscribed" class="order-btn" type="primary" disabled>已订阅</el-button>
              <el-button v-else class="order-btn" type="primary" @click.stop="subscribeItem(item.id)">订阅课程</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCourseList, getLatestList, getBannerList } from '@/api/index'
import { subscribe } from '@/api/video'
import getPermisson from '@/authentication/permission'
import { getId, getToken } from '@/utils/auth'
import { logout } from '@/utils/logout'
// import { getId } from '@/utils/auth'
export default {
  name: 'homePage',
  props: {},
  data () {
    return {
      // 列表
      // banner
      bannerLists: [],
      // 最近观看
      lastedWatched: [],
      // 病理诊断体系课程
      pathologyCourseList: [],
      // 病理大咖说
      masterCourseList: [],
      // 衡道讲堂
      HCourseList: [],
      // 衡道讲堂热门版
      HFirst: {},
      Hlasted: [],
      // 白求恩病理学社
      BethuneList: [],
      lungList: [],
      // 技术达人精品课
      tecCourseList: [],
      // 学术会议
      academicCourseList: [],
      // IMDT&疑难病例谈论
      IMDTCourseList: [],
      // 系统化课程
      moreSystem: true,
      // 衡道讲堂更多
      hengMoreShow: true,
      // IMD疑难病例更多
      IMDMore: true,
      // loading容器
      loading: '',
      hengLoading: false,
      hengLoading1: false,
      BethMore: true
    }
  },
  computed: {
    userId () {
      return this.$store.state.userId || getId()
    },
    // 病理诊断系统展开之后行数
    pathologyRow () {
      return Math.ceil(this.pathologyCourseList.courses.length / 4)
    },
    // 衡道讲堂展开之后的行数
    HRow () {
      return Math.ceil(this.HCourseList.courses.length / 4)
    },
    // IMD展开之后的行数
    IMDRow () {
      return Math.ceil(this.IMDTCourseList.courses.length / 2)
    },
    BethRow () {
      return Math.ceil(this.BethuneList.courses.length / 2)
    }
  },
  beforeRouteUpdate (to, from, next) {
    getPermisson().then((res) => {
      if (getId()) {
        this.getLatestList()
      }
      this.getCourseList()
      this.getBannerList()
    })
  },
  created () {
    getPermisson().then((res) => {
      if (getId()) {
        this.getLatestList()
      }
      this.getCourseList()
      this.getBannerList()
    })
  },
  mounted () {
  },
  watch: {},
  methods: {
    // 衡道讲堂的动画
    HMoreCourse () {
      this.hengMoreShow = false
      this.hengLoading = true
      var that = this
      setTimeout(() => {
        that.hengLoading = false
      }, 550)
    },
    HLessCourse () {
      this.hengMoreShow = true
      this.hengLoading1 = true
      var that = this
      setTimeout(() => {
        that.hengLoading1 = false
      }, 850)
    },
    // 病理诊断体系动画
    toMoreCourse () {
      this.moreSystem = false
      var that = this
      this.$refs.moreContent.style.transition = 'all ease 0.5s'
      // 每行内容是355px
      this.$refs.moreContent.style.height = 355 * this.pathologyRow + 20 + 'px'
      setTimeout(() => {
        that.moreSystem = false
      }, 500)
    },
    toLessCourse () {
      this.moreSystem = ''
      var that = this
      this.$refs.moreContent.style.transition = 'all ease 0.5s'
      this.$refs.moreContent.style.height = '355px'
      setTimeout(() => {
        that.moreSystem = true
      }, 500)
    },
    // IMD疑难病理动画
    toMoreIMDCourse () {
      this.IMDMore = ''
      var that = this
      this.$refs.moreIMDContent.style.transition = 'all ease 0.5s'
      // 每行内容是355px
      this.$refs.moreIMDContent.style.height = 185 * this.IMDRow + 20 + 'px'
      setTimeout(() => {
        that.IMDMore = false
      }, 500)
    },
    toLessIMDCourse () {
      this.IMDMore = ''
      var that = this
      this.$refs.moreIMDContent.style.transition = 'all ease 0.5s'
      this.$refs.moreIMDContent.style.height = '195px'
      setTimeout(() => {
        that.IMDMore = true
      }, 500)
    },
    // 白求恩肿瘤病理学社
    toMoreBethCourse () {
      this.BethMore = ''
      var that = this
      this.$refs.moreBethContent.style.transition = 'all ease 0.5s'
      // 每行内容是355px
      this.$refs.moreBethContent.style.height = 190 * this.BethRow + 20 + 'px'
      setTimeout(() => {
        that.BethMore = false
      }, 500)
    },
    toLessBethCourse () {
      this.BethMore = ''
      var that = this
      this.$refs.moreBethContent.style.transition = 'all ease 0.5s'
      this.$refs.moreBethContent.style.height = '200px'
      setTimeout(() => {
        that.BethMore = true
      }, 500)
    },
    async getBannerList () {
      const res = await getBannerList()
      this.bannerLists = res.data
    },
    // 点击banner第二张进入课程视频
    clickBanner (index, item) {
      if (item.url) {
        if (item.url.includes('http')) {
          window.open(item.url)
        } else if (item.url.includes('video')) {
          var id = item.url.substr(7)
          this.toVideo(id)
        } else {
          localStorage.setItem('toPath', JSON.stringify({path: item.url}))
          if (!getToken()) {
            if (getId()) {
              this.$message.error('登录过期，请先进行登录')
            } else {
              this.$message.error('请先进行登录')
            }
            logout(true)
            return
          }
          this.$router.push(item.url)
        }
      }
    },
    // 订阅课程
    async subscribeItem (id) {
      // 没有登录时候先进行登录
      if (!getToken()) {
        if (getId()) {
          this.$message.error('登录过期，请先进行登录')
        } else {
          this.$message.error('请先进行登录')
        }
        logout(true)
        return
      }
      let res = await subscribe(id, getId())
      if (res.code === 200) {
        this.$message.success('订阅成功')
        // 把课程中订阅状态改成成功状态
        this.pathologyCourseList.courses.forEach(ele => {
          if (ele.id === id) {
            ele.subscribed = true
          }
        })
        this.academicCourseList.courses.forEach(ele => {
          if (ele.id === id) {
            ele.subscribed = true
          }
        })
      }
    },
    // 课程列表
    async getCourseList () {
      let id = getId()
      let params = {
        userId: id,
        system: 'PC',
        pageSize: 200
      }
      let res = await getCourseList(params)
      const courseList = res.data
      var masterCourseList
      courseList.forEach((ele) => {
        if (ele.name === '病理诊断体系课程') {
          this.pathologyCourseList = ele
        } else if (ele.name === 'iMDT&疑难病例讨论') {
          this.IMDTCourseList = ele
        } else if (ele.name === '衡道讲堂') {
          this.HCourseList = ele
        } else if (ele.name === '白求恩·肿瘤病理学社') {
          this.BethuneList = ele
        } else if (ele.name === '学术会议') {
          this.academicCourseList = ele
        } else if (ele.name === '技术达人精品课') {
          this.tecCourseList = ele
        } else if (ele.name === '病理大咖说') {
          masterCourseList = ele
        } else if (ele.name === '「肺」你莫属，乘风破Lung的RET') {
          this.lungList = ele
        }
      })
      // 病理大咖说 只要前四个内容
      this.masterCourseList = masterCourseList.courses.slice(0, 4)
      // 衡道讲堂
      this.HFirst = this.HCourseList.courses[0]
      this.Hlasted = this.HCourseList.courses.slice(1, 7)
    },
    async getLatestList () {
      let pageCondition = {
        startPage: 0,
        pageSize: 4,
        sort: 'updateTime',
        direction: 'DESC'
      }
      let id = getId()
      let res = await getLatestList(id, pageCondition)
      if (res) {
        this.lastedWatched = []
        res.data.contents.forEach((ele, index) => {
          if (index < 2) {
            var min = Math.floor(ele.latestEndTime / 60)
            var sec = ele.latestEndTime - min * 60
            ele.times = min + '分' + sec + '秒'
            this.lastedWatched.push(ele)
          }
        })
      }
    },
    mouseoverimg (index) {
      this.$refs.playicon[index].style.display = 'block'
    },
    mouseoutimg (index) {
      this.$refs.playicon[index].style.display = 'none'
    },
    mouseoverimgmaster (index) {
      this.$refs.playiconMaster[index].style.display = 'block'
    },
    mouseoutimgmaster (index) {
      this.$refs.playiconMaster[index].style.display = 'none'
    },
    mouseoverimgtec (index) {
      this.$refs.playiconTec[index].style.display = 'block'
    },
    mouseoutimgtec (index) {
      this.$refs.playiconTec[index].style.display = 'none'
    },
    toVideo (id) {
      localStorage.setItem('fromPath', JSON.stringify({path: '/index'}))
      localStorage.setItem('toPath', JSON.stringify({path: '/video', id}))
      if (!getToken()) {
        if (getId()) {
          this.$message.error('登录过期，请先进行登录')
        } else {
          this.$message.error('请先进行登录')
        }
        logout(true)
        return
      }
      this.$router.push({path: `/video/${id}`})
    },
    initialPage () {
      this.getCourseList()
      this.getLatestList()
    }
  },
  components: {}
}
</script>

<style scoped lang="scss">
.home-page {
  .home-banner {
    .carousel {
      height: 16.7vw;
      min-width: 1200px;
      min-height: 200px;
      /deep/ .el-carousel__container {
        height: 100% !important;
        h3 {
          margin-block-start: 0px;
        }
        img {
          width: 100%;
        }
      }
      .activedItem{
        cursor: pointer;
      }
      /deep/ .el-carousel__indicators {
        .el-carousel__button {
          width: 10px;
          height: 10px;
          background: #ffffff;
          opacity: 0.46;
          border-radius: 50%;
        }
        .el-carousel__indicator.is-active button {
          width: 10px;
          height: 10px;
          background: #92e4bb;
          border-radius: 50%;
        }
      }
    }
  }
  .home-container {
    width: 1200px;
    margin: 0 auto;
    min-height:calc( 100vh - 289px - 288px);
    .course {
      margin-bottom: 80px;
    }
    //最近观看
    .last-watch {
      margin-top: 41px;
      .no-record{
        color: #666666;
        font-size:16px;
        margin: 0px auto 100px;
        text-align: center;
      }
      .content {
        display: flex;
        justify-content: space-between;
        .item {
          display: flex;
          width: 590px;
          height: 126px;
          background: #f7f8fa;
          border-radius: 8px;
          transition: all linear 0.2s;
          &:hover {
            transform: translateY(-7px);
            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
          }
          .img-box {
            margin: 15px;
            width: 132px;
            height: 93px;
            border-radius: 5px;
            overflow: hidden;
            cursor:inherit;
            box-shadow: none;
            &:hover {
            transform: translateY(0px);
            box-shadow: none;
          }
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .desc {
            display: flex;
            margin-left: 5px;
            flex-direction: column;
            justify-content: space-between;
            margin-bottom: 20px;
            .desc-title {
              margin-top: 20px;
              color: #333;
              font-size: 16px;
            }
            .author {
              display: flex;
              font-size: 14px;
              height: 22px;
              line-height:22px;
              .author-title {
                width: 46px;
                height: 22px;
                background: #ff6f00;
                border: 1px solid #ff6f00;
                opacity: 0.8;
                border-radius: 4px;
                color: #fff;
                text-align: center;
                line-height: 22px;
                margin-right: 7px;
              }
              .author-name {
                color: #666;
              }
            }
            .saw-time {
              font-size: 10px;
              color: #999;
            }
          }
          .continue-btn {
            flex-grow: 1;
            // margin-right: 30px;
            position: relative;
            color: #fff;
            font-size: 13px;
            line-height: 24px;
            text-align: center;
            /deep/ .el-button--primary {
              position: absolute;
              right: 30px;
              bottom: 20px;
              border-radius: 12px;
              width: 81px;
              height: 24px;
              border-color: #26bf9b;
              background-color: #26bf9b;
            }
            /deep/ .el-button--primary:hover{
              background-color: #00A47D;
            }
          }
        }
      }
    }
    // 病理诊断系统化课程
    .system-course {
      .title{
        margin-bottom:12px;
      }
      .content {
        align-content: flex-start;
        .img-box {
          width: 285px;
          height: 329px;
          &:nth-child(-n+4){
            margin-bottom: 40px;
            margin-top:20px;
          }
          .img-desc {
            height: 153px;
            padding: 18px;
            .desc-title {
              font-size: 16px;
              color: #333;
              line-height: 27px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .desc-author {
              height: 24px;
              line-height: 24px;
              display: flex;
              justify-content: space-between;
              font-size: 14px;
              .author-title {
                width: 46px;
                height: 24px;
                background: #eeeeee;
                opacity: 0.8;
                border-radius: 4px;
                color: #666;
                text-align: center;
                line-height: 24px;
              }
              .author-name {
                color: #666;
              }
              .author-status {
                margin-left: 24px;
                color: #999;
              }
              .author-number {
                color: #999;
              }
            }
          }
        }
      }
    }
    // 白求恩病理学社
    .bethuneList-course {
      .title{
        margin-bottom:12px;
      }
      .content {
        .img-box {
          margin-bottom: 20px;
          width: 590px;
          height: 180px;
          border-radius: 10px;
          overflow: hidden;
          box-sizing: border-box;
          &:nth-child(even) {
            margin-right: 0px;
          }
          &:nth-child(-n+2){
            margin-top:20px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    // 衡道讲堂
    .hengdao-course {
      .title{
        margin-bottom: 12px;
      }
      .content {
        // height:400px;
        // 更多的样式
        align-content: flex-start;
        overflow: hidden;
        .img-box {
          width: 285px;
          height: 195px;
          margin-bottom: 25px;
          &:nth-child(-n+4){
            margin-top:20px
          }
          img {
            height: 145px;
          }
        }
      }
      // 默认的样式
      .hot-content {
        justify-content: space-between;
        align-content: flex-start;
        .hot-item {
          width: 284px;
          height: 400px;
          margin-top:20px;
          img {
            height:100%;
            width:100%;
            border-radius: 8px;
          }
        }
        .general-content{
          display:flex;
          flex-wrap:wrap;
          width:895px;
          .img-box{
            margin-bottom: 0;
            margin-top:20px;
            &:nth-child(3n){
              margin-right: 0px;
            }
            &:nth-child(4n){
              margin-right: 16px;
            }
            // &:nth-child(n-3){
            //   margin-top: 20px;
            // }
            .img{
              position: relative;
              .imgmask{
                width: 100%;
                height: 100%;
                display: none;
                position: absolute;
                background: rgba(0, 0, 0, .3);
                .play-icon{
                  width: 40px;
                  height: 40px;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  margin-top: -20px;
                  margin-left: -20px;
                  background-image: url(../assets/play.png);
                  background-repeat: no-repeat;
                  background-size: 100%;
                  background-position: center;
                }
              }
            }
            .img-desc{
              .desc-title{

              }
            }
          }

        }
      }
    }
    // 技术达人精品课
    .tec-course {
      .img-box {
        width: 285px;
        height: 235px;
      }
    }
    .lung-course{
      .content{
        width: 100%;
        .img-box{
          width: 100%;
        }
        img{
          width: 100%;
          height: 220px;
        }
      }
    }
    // 学术会议
    .academic-course {
      .content {
        .img-box {
          width: 285px;
          height: 329px;
        }
      }
    }
    // IMDT课程
    .IMDT-course {
      .title{
        margin-bottom:12px;
      }
      .content {
        .img-box {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 21px;
          width: 590px;
          height: 165px;
          padding: 20px;
          background: #f7f8fa;
          // box-shadow: 0px 4px 9px 1px rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          box-sizing: border-box;
          &:nth-child(even) {
            margin-right: 0px;
          }
          &:nth-child(-n+2){
            margin-top:20px;
          }
          .img {
            width: 205px;
            height: 125px;
            margin-right: 18px;
            border-radius: 4px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .img-desc {
            line-height: 27px;
            padding: 0px;
            .desc-title {
              font-size: 18px;
              color: #333;
              margin-bottom: 50px;
              margin-top: 10px;
            }
            .desc-origin {
              margin-bottom: 29px;
              font-size: 16px;
              color: #666;
            }
            .desc-date {
              font-size: 14px;
              color: #999;
            }
          }
        }
      }
    }
  }
  // 公共样式
  // content
  .content {
    display: flex;
    flex-wrap: wrap;
  }
  // 图片盒子
  .img-box {
    cursor:pointer;
    margin-right: 16px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    overflow: hidden;
    transition: all linear 0.2s;
    &:hover {
      transform: translateY(-7px);
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    }
    &:nth-child(4n) {
      margin-right: 0px;
    }
    .img{
      position: relative;
      .imgmask{
        width: 100%;
        height: 100%;
        position: absolute;
        background: rgba(0, 0, 0, .3);
        display: none;
        .play-icon{
          width: 40px;
          height: 40px;
          position: absolute;
          left: 50%;
          top: 50%;
          margin-top: -20px;
          margin-left: -20px;
          background-image: url(../assets/play.png);
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
        }
      }
    }
    img {
      height: 175px;
      width: 100%;
      display: block;
    }
    .img-desc {
      height: 90px;
      padding: 15px;
      .desc-title {
        margin-bottom: 5px;
        font-size: 16px;
        color: #333;
      }
      .desc-detail {
        display: flex;
        justify-content: space-between;
        line-height: 27px;
        font-size: 14px;
        color: #999;
      }
    }
  }
  .title {
    height: 27px;
    margin-bottom: 30px;
    font-size: 24px;
    color: #333;
    line-height: 27px;
    display: flex;
    justify-content: space-between;
    .more {
      color: #999;
      font-size: 14px;
      padding-right: 10px;
      cursor: pointer;
      &:hover{
        color:#26bf9b;
      }
    }
  }
  // 按钮样式
  .order-btn {
    margin-top: 26px;
    width: 250px;
    height: 35px;
    line-height: 35px;
    background: #26bf9b;
    border-radius: 8px;
  }
  /deep/ .el-button--primary {
    border-color: #26bf9b;
    background-color: #26bf9b;
  }
  /deep/ .el-button--primary:hover {
    border-color: #00A47D;
    background-color: #00A47D;
  }
  // 禁止按钮样式
  /deep/ .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
    color:#26bf9b;
    cursor: not-allowed;
    background: #F7F8FA;
    border: 1px solid #EEEEEE;
    border-radius: 8px;
  }
  /deep/ .el-button--primary {
    border-color: #26bf9b;
    background-color: #26bf9b;
  }
  /deep/ .el-button {
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue